import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { RestSchemas, useRestClient } from '@/contexts/QueryProvider'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { toast } from 'sonner'
import { EventSchedulerForm } from '../../Forms/EventSchedulerForm'
import { useCurrentWorkspace } from '../../useCurrentWorkspace'

type WorkspaceSchedule = RestSchemas['Messages.Scheduler.ExistingSchedule']

export function RowActionsMenu({ row }: { row: WorkspaceSchedule }) {
  const { workspaceId } = useCurrentWorkspace()
  const { deleteSchedulerApiDeleteSchedule, getSchedulerApiGetSchedules } = useRestClient()

  const { mutate: deleteSchedule } = deleteSchedulerApiDeleteSchedule.useMutation(undefined, {
    onSuccess: () => {
      getSchedulerApiGetSchedules.invalidateQueries({
        parameters: {
          path: { workspaceId },
        },
      })
      toast.success('Schedule deleted')
    },
    onError: () => {
      toast.error('Failed to delete schedule')
    },
  })

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="size-8 rounded-full">
          <IconMenuOutline size={16} />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <EventSchedulerForm
          selectedSchedule={row}
          sheetTitle="Edit scheduler"
          sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Edit scheduler</DropdownMenuItem>}
        />
        <ConfirmDialog
          title="Delete scheduler"
          description="Are you sure you want to delete this schedule?"
          onConfirm={() =>
            deleteSchedule({
              path: {
                workspaceId,
                scheduleId: row.id,
              },
            })
          }
          trigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              Delete scheduler
            </DropdownMenuItem>
          }
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
